import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=15758173&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15758173')) {
      api.createRecord('15758173', component.options)
    } else {
      api.reload('15758173', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=15758173&", function () {
      api.rerender('15758173', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20RYvcIVcSRAK/JS/imageCarousel.vue"
export default component.exports